/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { Component } from 'react';
import Logo from '../_shared/logo';
import styles, { PolicyLink } from './footer.styles';

interface IProps {
  shouldExtend?: boolean;
}

export class Footer extends Component<IProps> {
  render() {
    const { shouldExtend } = this.props;
    return (
      <div
        css={css(styles.container, shouldExtend && styles.extended)}
        className={'Footer'}
      >
        <div
          css={css(
            styles.logo_1_container,
            shouldExtend && styles.logo_1_container_centered
          )}
        >
          <Logo
            size={shouldExtend ? 'small' : 'large'}
            width={120}
            type={'aeras_white'}
            style={shouldExtend ? {} : { marginLeft: 20 }}
          />
        </div>
        {!shouldExtend && (
          <div css={css(styles.policyContainer)}>
            <PolicyLink
              href={'https://www.aerasintel.com/terms-of-use'}
              target="_blank"
            >
              Terms of Use
            </PolicyLink>
            <p css={css(styles.divider)}>|</p>
            <PolicyLink
              href={'https://www.aerasintel.com/privacy-policy'}
              target="_blank"
            >
              Privacy Policy
            </PolicyLink>
          </div>
        )}
        {!shouldExtend && <div css={css(styles.logo_2_container)} />}
      </div>
    );
  }
}
